// Root `/` now serves the NEW-design homepage (design default flipped to new).
// The OLD homepage lives at /old (pages/old.js). /new remains a working alias.
// HomeNew's canonical is already https://www.shippop.com/ so URL == canonical here.
export { default, getServerSideProps } from './new'
